export default __webpack_public_path__ + "static/media/task-done.3b99c12c.svg";